import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { fetchCoins } from "../api/cryptoService";

const CoinsContext = createContext(null);

export function CoinsProvider({ children }) {
  const [coins, setCoins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refetchCoins = useCallback(async () => {
    setLoading(true);
    setError(null);
    const data = await fetchCoins();
    if (data) {
      setCoins(Array.isArray(data) ? data : []);
    } else {
      setCoins([]);
      setError("Unable to load coins. Please try again later.");
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    refetchCoins();
  }, [refetchCoins]);

  const value = useMemo(
    () => ({
      coins,
      loading,
      error,
      refetchCoins,
    }),
    [coins, loading, error, refetchCoins]
  );

  return (
    <CoinsContext.Provider value={value}>{children}</CoinsContext.Provider>
  );
}

export function useCoinsContext() {
  const ctx = useContext(CoinsContext);
  if (!ctx) {
    throw new Error("useCoinsContext must be used within CoinsProvider");
  }
  return ctx;
}
